import { render, staticRenderFns } from "./FilterMenuMultiTags.vue?vue&type=template&id=4905677b"
import script from "./FilterMenuMultiTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterMenuMultiTags.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports